module.exports = __webpack_public_path__ + "SitePenLogo_Light.3ofX7f2Z.svg";